import React, { FC, MouseEvent } from 'react';
import styles from './search_filters_radio.module.scss';

type Props = {
  onClick?: (event: MouseEvent<HTMLDivElement>) => void;
};

export const SearchFiltersRadio: FC<Props> = ({ onClick, children }) => (
  <div className={styles.container} {...({ onClick } || {})}>
    {children}
  </div>
);

export const SearchFiltersRadioLabel: FC = ({ children }) => (
  <label className={styles.container}>{children}</label>
);
